import {queryOptions} from '@tanstack/react-query';
import {fetchBillingDiscounts} from './fetchBillingDiscounts';

export const billingDiscountsQuery = queryOptions({
  queryFn: fetchBillingDiscounts,
  queryKey: ['billing', 'discounts'],
});
